export enum EntityType {
    Individual = 'Individual',
    Business = 'Business'
}

export enum EnumMailingAddress {
    SameMailing = 'SameMailing',
    DifferenceMailing = 'DifferenceMailing'
}
